import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=a6daab9a&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Aside.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Aside.vue
// module id = null
// module chunks = 